import React, {
  memo, useCallback, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableListerCell from '../tablecell';
// import baseMD from '../../../../../constants/meta/documents/base';

function TableDocListerRow({
  row, columns, onFocus, selected, tabIndex, onContextMenu, actions, children,
}) {
  const onClickHandler = useCallback(
    (e) => {
      onFocus(e, row.id);
    },
    [onFocus, row.id],
  );

  const sx = useMemo(
    () => ({
      fontWeight: (typeof row.executed === 'undefined') || row.executed ? 'bold' : 'light',
      color: (typeof row.executed === 'undefined') || row.executed ? 'success.main' : 'text.disabled',
    }),
    [row.executed],
  );

  return (
    <TableRow
      data-id={row.id}
      hover
      selected={selected}
      onClick={onClickHandler}
      sx={sx}
      tabIndex={tabIndex}
      onDoubleClick={(e) => actions.onRowDoubleClick(e, row.id)}
    >
      {columns.map((c) => (
        <TableListerCell
          key={c.key}
          value={row[c.key]}
          variants={c.variants}
          choices={c.choices}
          type={c.type}
          onContextMenu={(e) => onContextMenu(e, row.id)}
          sx={sx}
        />
      ))}
      { children }
    </TableRow>

  );
}

TableDocListerRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.oneOf([
      'string', 'email', 'url', 'integer', 'float', 'decimal', 'choice', 'date', 'datetime', 'nested object', 'boolean', 'field',
    ]),
  })).isRequired,
  row: PropTypes.shape({
    id: PropTypes.number.isRequired,
    deleted: PropTypes.bool,
    executed: PropTypes.bool.isRequired,
  }).isRequired,
  onFocus: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  tabIndex: PropTypes.number.isRequired,
  onContextMenu: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

TableDocListerRow.defaultProps = {
  selected: false,
  children: null,

};
export default memo(TableDocListerRow);
